<template>
  <div class="course-wrap">
    <div>
      <div class="item border-bottom" v-for="(item,index) in list" :key="item.course_id">
        <div class="num">{{index+1}}</div>
        <div class="cover"><img :src="item.icon" alt=""></div>
        <router-link tag="div" class="con" :to="(item.type == 1?'/play/'+item.course_id+'/'+item.video_id:'/systematic/'+item.course_id)">
          <div class="title">{{item.title}}</div>
          <div class="teacher">大咖：{{item.name}}</div>
        </router-link>
        <div class="browser">
          <img src="~common/image/rank-hot.png" alt=""> <span>{{item.sum_total}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRankList} from '@/api/rank'
export default {
  data() {
    return {
      list: []
    }
  },
  created() {
    getRankList(1).then(data => {
      if (data) {
        this.list = data
      }
    })
  }
}
</script>

<style lang="stylus" scoped>
@import "~common/stylus/variable"
.course-wrap{
  padding: 0 size(40)
  >div{
    border-radius size(18)
    background #fff
    padding 0 size(26)
    .item{
      display flex
      height size(162)
      align-items center
      &:before{
        background #f4f4f4
      }
      &:nth-child(1),&:nth-child(2),&:nth-child(3){
        .num{
          font-size 0
          height size(62)
          background-size 100% 100%
        }
      }
      &:nth-child(1){
        .num{
          background-image url('~common/image/rank-1.png')
        }
      }
      &:nth-child(2){
        .num{
          background-image url('~common/image/rank-2.png')
        }
      }
      &:nth-child(3){
        .num{
          background-image url('~common/image/rank-3.png')
        }
      }
      .num{
        width size(52)
        text-align center
        font-size size(44)
        color #bcc4ce
        text-align center
      }
      .cover{
        width size(92)
        height size(109)
        border-radius 4px
      // background gold
        margin-left size(16)
        overflow hidden
        img{
          display block
          width 100%
          height 100%
        }
      }
      .con{
        flex 1
        padding 0 size(14)
        padding-left size(18)
        line-height 1.2
      }
      .title{
        font-size size(30)
        color #5f6366
        txt-overflow(2)
        font-weight 800
      }
      .teacher{
        color #7f7f7f
        font-size size(26)
        margin-top size(6)
      }
      .browser{
        padding-left size(8)
        min-width size(90)
        text-align right
        color #5f5f5f
        font-size 0
        img{
          width size(24)
          display inline-block
          margin-right 2px
        }
        span{
          font-size size(26)
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rank/course.vue